<template>
  <div class="comm_scrInput_wrap">
    <div>
      <sui-text-field
        ref="gbmInfo"
        v-model="gbmInfo.gbmName"
        style="width:100%;"
        fixedIcon
        :readonly="readonly"
        :maxlength="maxlength"
        @clear-input="reset"
        @focus="focus"
        @keyup.enter="onGbmClick"
      />
    </div>
    <sui-button
      type="button"
      class="comm_btn_InputScr"
      @click="onGbmClick"
    />
  </div>
</template>
<script>
export default {
  name: 'CmpSiteGbmSelect',
  props: {
    selectedGbmInfo: {
      type: Object,
      default() {
        return {
          gbmCode: '',
          gbmName: '',
        };
      },
    },
    readonly: {
      type: Boolean,
      default() {
        return false;
      },
    },
    maxlength: {
      type: String,
      default: '100',
    },
  },
  data() {
    return {
      gbmInfo: this.selectedGbmInfo,
    };
  },
  methods: {
    onGbmClick() {
      utils.openLayerPopup('PGE_CMY_00026', this.onGbmPopupCallback, {
        pageInitialData: this.gbmInfo,
        size: 'xl',
      });
    },
    onGbmPopupCallback(nodeData) {
      if (nodeData && nodeData.length > 0) {
        // const gbmInfoData = [];
        // let gbmNameArr = '';
        // // console.log(nodeData);
        // utils.forEach(nodeData, (value, key) => {
        //   gbmInfoData.push({
        //     gbmName: nodeData[key].gbmName,
        //     gbmCode: nodeData[key].gbmCode,
        //   });
        //   gbmNameArr += `${nodeData[key].gbmName}${', '}${nodeData[key].gbmCode}${' / '}`;
        // });
        // this.gbm.gbmName = gbmNameArr;

        this.gbmInfo.gbmCode = nodeData[0].gbmCode;
        this.gbmInfo.gbmName = nodeData[0].gbmName;

        console.log(this.gbmInfo);
        this.$emit('selected', nodeData[0]);
      }
    },
    focus() {
      this.$refs.gbmInfo.setFocus();
    },
    reset() {
      this.gbmInfo.gbmCode = '';
      this.gbmInfo.gbmName = '';
      this.$emit('selected', this.nodeData[0]);
    },
  },
};
</script>
<style scoped>
</style>
